import 'react-toastify/dist/ReactToastify.css';
import { Slide } from 'react-toastify';
import { Toast } from './styles/styled/Toast.styled';
import { ReactComponent as CloseIcon } from './assets/icons/close.svg';
import { CssBaseline , ThemeProvider} from "@mui/material";
import './App.css';
import './styles/Buttons.css';
import './styles/SearchFilter.css';
import './styles/Table.css';
import './styles/Modal.css';
import './styles/Header.css';
import './styles/Login.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { logout } from './actions/security';
import { SET_CURRENT_USER } from './actions/types';
import setJwtToken from './securityUtils/setJwtToken';
import authorizationService from './securityUtils/authorizationService';
import Footer from './components/Layout/Footer';
import LandingPage from './components/Layout/LandingPage/LandingPage';
import Login from './components/Security/Login';
import SecuredRoute from './securityUtils/secureRoute';
import UserContainer from './components/Containers/UserContainer';
import SignUp from './components/User/SignUp';
import UserRoleContainer from './components/Containers/UserRoleContainer';
import { theme } from './theme';
import Header from './components/Layout/Header/Header';
import ProductCategoryContainer from './components/Containers/ProductCategoryContainer';
import ProductContainer from './components/Containers/ProductContainer';

import VehicleModelContainer from './components/Containers/VehicleModelContainer';
import BrandContainer from './components/Containers/BrandContainer';
import VehicleContainer from './components/Containers/VehicleContainer';
import TravelOrderContainer from './components/Containers/TravelOrderContainer';
var jwtDecode = require('jwt-decode');
const jwtToken = localStorage.jwtToken;

if (jwtToken) {
  setJwtToken(jwtToken);
  const decoded_jwtToken = jwtDecode(jwtToken);

  store.dispatch({
    type: SET_CURRENT_USER,
    payload: decoded_jwtToken,
  });

  const currentTime = Date.now() / 1000;
  if (decoded_jwtToken.exp < currentTime) {
    store.dispatch(logout());
    window.location.href = '/';
  }
}
authorizationService.startRefresh();

const App = () => {
    return (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
         <Toast
            position="bottom-left"
            transition={Slide}
            style={{ bottom: '4.5em' }}
            hideProgressBar
            closeButton={<CloseIcon />}
          />
        <Router>
          <CssBaseline />
          <Header/>
          <div className="App content-min-height">
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signUp" component={SignUp} />             
            <SecuredRoute exact path="/roleList" component={UserRoleContainer} />
            <SecuredRoute exact path="/userList" component={UserContainer} />
            <SecuredRoute exact path="/productCategoryList" component={ProductCategoryContainer} />
            <SecuredRoute exact path="/productList" component={ProductContainer} />
            <SecuredRoute exact path="/vehicle" component={VehicleContainer} />
            <SecuredRoute exact path="/vehicleModel" component={VehicleModelContainer} />
            <SecuredRoute exact path="/brand" component={BrandContainer} />
            <SecuredRoute exact path="/travelOrder" component={TravelOrderContainer} />
            </Switch>
          </div>
          <Footer />
        </Router>
        </ThemeProvider>
      </Provider>
    );
}

export default App;
